import * as React from 'react';
import {getMeta, Types, TypeImplementation} from '@packages/systems/wfdl';
import {
  ExpressionEditor,
  updateExpressionAction,
} from '@packages/systems/ExpressionEditor-utils';
import {styledDiv} from '@packages/utilities/styled';
import {FinePrint} from '@packages/systems/design-system/Text';
import {RadioSelect} from '@packages/systems/design-system/RadioSelect';
import {WebPaymentsNote} from '../settings/WebPaymentsNote';

import {TText, EText} from '@packages/systems/wfdl-ast';

import {
  ContextualExpressions,
  stripAnn,
  getAnn,
} from '@packages/utilities/contextual-expression';

const Gutters = styledDiv(({theme}) => ({
  marginTop: theme.gutters.base + 4,
}));

type Props = {
  label: string;
  value: string;
  textStates: Array<{
    label: string;
    subtext?: string;
    key: string;
  }>;
  onSelectItem: (arg1: string) => void;
  hasNote: boolean;
};

export const Component = ({
  label,
  textStates,
  value,
  onSelectItem,
  hasNote,
}: Props) => {
  return (
    <div data-automation-id="radio-select">
      <FinePrint>{label}</FinePrint>
      <Gutters>
        <RadioSelect
          items={textStates}
          selectedKey={value}
          onSelectItem={onSelectItem}
        />
      </Gutters>

      {hasNote ? <WebPaymentsNote /> : null}
    </div>
  );
};

export const WebPaymentsSelect = TypeImplementation.Alias({
  type: TText,
  render: ({expr, dispatch}) => {
    const strippedExpr = stripAnn(expr);
    const text = ContextualExpressions.getText(strippedExpr);

    const {type} = getAnn(expr);

    if (type === null) {
      throw Error('Expected type from AnnotatedExpression to be defined');
    }

    const label = Types.getLabel(type);
    const meta = getMeta(type);
    const textStates = meta?.textStates;
    const hasNote = Boolean(meta?.hasNote);

    if (text !== null && Array.isArray(textStates)) {
      const toggleSwitchState = (newValue: string) => {
        dispatch(updateExpressionAction(EText(newValue)));
      };

      return (
        <Component
          label={label}
          textStates={textStates}
          value={text}
          onSelectItem={toggleSwitchState}
          hasNote={hasNote}
        />
      );
    } else {
      return <ExpressionEditor expression={expr} dispatch={dispatch} />;
    }
  },
});
